/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LedgerBoardPrize
 */
export interface LedgerBoardPrize {
    /**
     * 
     * @type {string}
     * @memberof LedgerBoardPrize
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LedgerBoardPrize
     */
    name: string;
    /**
     * Absent when the reward carries no artwork.
     * @type {string}
     * @memberof LedgerBoardPrize
     */
    imageUrl?: string;
}

/**
 * Check if a given object implements the LedgerBoardPrize interface.
 */
export function instanceOfLedgerBoardPrize(value: object): value is LedgerBoardPrize {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function LedgerBoardPrizeFromJSON(json: any): LedgerBoardPrize {
    return LedgerBoardPrizeFromJSONTyped(json, false);
}

export function LedgerBoardPrizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LedgerBoardPrize {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}

export function LedgerBoardPrizeToJSON(json: any): LedgerBoardPrize {
    return LedgerBoardPrizeToJSONTyped(json, false);
}

export function LedgerBoardPrizeToJSONTyped(value?: LedgerBoardPrize | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'imageUrl': value['imageUrl'],
    };
}

